module.exports = __webpack_public_path__ + "static/media/HardlopenvoorBedrijven-28.1992ec35.jpg";